import { initialState } from '@/features/sante-mobilite/santeMobiliteSlice';
import { SanteMobiliteState } from '@/features/sante-mobilite/types';

const STORAGE_KEY = 'santeMobiliteState';

export const loadSanteMobiliteState = (): SanteMobiliteState => {
  try {
    const serializedState = localStorage.getItem(STORAGE_KEY);
    if (!serializedState) return initialState;
    return JSON.parse(serializedState);
  } catch (e) {
    console.warn('Failed to load santeMobilite state from localStorage:', e);
    return initialState;
  }
};

export const saveSanteMobiliteState = (state: SanteMobiliteState) => {
  try {
    if (!state) return;
    const serializedState = JSON.stringify(state);
    localStorage.setItem(STORAGE_KEY, serializedState);
  } catch (e) {
    console.warn('Failed to save santeMobilite state:', e);
  }
};
